import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import Spine = PIXI.spine.Spine;
import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";

export class WildMining extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "WildMining";
    }

    public onWildMining(): gsap.core.Timeline {
        const wildMiningBanner: Spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("wildMining"));
        return gsap.timeline().add([
            () => {
                FITH2SoundManager.playSound("textSweep");
                wildMiningBanner.position.set(360, 360);
                this.addChild(wildMiningBanner);
            },
            new SpineTween(wildMiningBanner, 0, "base")
        ]).add(() => {
            wildMiningBanner.destroy();
        });
    }
}